import React from 'react'
import PropTypes from 'prop-types'
import { Heading, Text } from '@plurall/elo'

import {
  messageWrapper,
  messageBlock,
  messageLoading,
  messageText,
  messageTitle,
} from './Hangouts.module.scss'

const { REACT_APP_ASSETS_URL } = process.env

export const Loading = ({ message }) => (
  <div className={messageWrapper} >
    <div className={messageLoading}>
      <img alt='Carregando' src={`${REACT_APP_ASSETS_URL}/static/assets/images/loading.gif`} />
    </div>
    <div className={messageBlock}>
      <Heading className={messageTitle} size='big' >Aguarde um instante</Heading>
      <Text className={messageText}>{message}</Text>
    </div>
  </div>
)

Loading.propTypes = {
  message: PropTypes.string,
}
